import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { RecaptchaErrorParameters, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { UtilsService } from '@core/services/utils.service';

@Component({
  selector: 'vass-recaptcha',
  standalone: true,
  template: `
    <div class="recaptcha-container"></div> 
  `,
  imports: [CommonModule, RecaptchaV3Module],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecaptchaComponent implements OnInit {

  private _utilS = inject(UtilsService);
  private recaptchaV3Service = inject(ReCaptchaV3Service);

  public captchaResponse = "";

  ngOnInit() {
    this.executeRecaptcha('homepage');
  }

  public async executeRecaptcha(action: string): Promise<void> {
    try {
      const token = await firstValueFrom(this.recaptchaV3Service.execute(action));
      if (token) {
        this.resolved(token);
      } else {
        throw new Error('No token recibido de reCAPTCHA');
      }
    } catch (error) {
      console.error('Error ejecutando reCAPTCHA:', error);
      this.onError(error as RecaptchaErrorParameters);
    }
  }

  private resolved(token: string): void {
    if (token) {
      this._utilS.tokenRecaptcha = token;
    }
  }

  private onError(errorDetails: RecaptchaErrorParameters): void {
    this.captchaResponse += `ERROR; Los detalles han sido registrados en la consola\n`;
    console.error(`reCAPTCHA error encontrado; detalles:`, errorDetails);
  }
}
